import { useSyncExternalStore } from 'react';
import { authStore, type AuthSnapshot } from './store';

export function useAuth(): AuthSnapshot {
  return useSyncExternalStore(
    (cb) => authStore.subscribe(cb),
    () => authStore.snapshot,
    () => authStore.snapshot,
  );
}
